export default () => ({
  list: {},
  item: {},
})
